import React, { createContext, useContext, useState,useEffect } from "react";
import { getCookie } from "./components/getcookie";
import axios from "axios";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const rolePermissionValue = localStorage.getItem("rolePermissionList");
  const userTypeValue = localStorage.getItem("userType")??[];
    const [rolePermissionList, setRolePermissionList] = useState(JSON.parse(rolePermissionValue)??[]);
             const [userType, setUserType] = useState(userTypeValue??"");
               const [refreshDockList, setRefreshDockList] = useState(false);
             useEffect(() => {             
              localStorage.setItem("rolePermissionValue", rolePermissionList);
              localStorage.setItem("userTypeValue", userType);
            }, [rolePermissionList]);
  return (
    <GlobalContext.Provider value={{ rolePermissionList, setRolePermissionList, userType,setUserType,refreshDockList, setRefreshDockList}}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);